import { render, staticRenderFns } from "./LikedProducts.vue?vue&type=template&id=dfb8e6c4&scoped=true&"
import script from "./LikedProducts.vue?vue&type=script&lang=js&"
export * from "./LikedProducts.vue?vue&type=script&lang=js&"
import style0 from "./LikedProducts.vue?vue&type=style&index=0&id=dfb8e6c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb8e6c4",
  null
  
)

export default component.exports